// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Cards_cardsContainer__hsdSj","card":"Cards_card__UK7Y7","name":"Cards_name__pQte4","title":"Cards_title__dQBtM","info":"Cards_info__nOYBc"};